import { Button, FilterButton } from 'react-admin';
import { RefreshButton, TopToolbar } from 'ra-ui-materialui';
import { useNavigate } from 'react-router';
import { usePermissions } from 'react-admin';
import { PersonAdd, PersonAddOutlined } from '@mui/icons-material';
import { ADD_ROUTE, ROLE_CREATE_USER } from '@/utils/CONST';

const UsersListActions = () => {
    const navigate = useNavigate();
    const handleClick = () => navigate(`${ADD_ROUTE}_user`);
    const handleClickToAddUser = () => navigate(`${ADD_ROUTE}_user_list`);
    const { permissions } = usePermissions();

    return (
        <TopToolbar sx={{ display: 'flex', alignItems: 'center' }}>
            <FilterButton />

            {permissions?.includes(ROLE_CREATE_USER) && (
                <Button data-cy={'add-user'} onClick={handleClick} label={'agency.list.users.add_new_user'}>
                    <PersonAddOutlined />
                </Button>
            )}

            {permissions?.includes(ROLE_CREATE_USER) && (
                <Button data-cy={'add-user'} onClick={handleClickToAddUser} label={'agency.list.users.add_user'}>
                    <PersonAdd />
                </Button>
            )}

            <RefreshButton
                data-cy='refresh-button'
                style={{
                    paddingLeft: '12px',
                    paddingRight: '12px',
                }}
            />
        </TopToolbar>
    );
};

export default UsersListActions;
